module.exports = __webpack_public_path__ + "img/example_label_similar.3b01c95e.png";